import { rest } from 'utils';

export default {
  getUrl: ({ url }) => rest.get({ baseUrl: url }),
  getFeatures: async () => {
    const { properties = {} } = (await rest.get({ url: '/locations/de/fra' })) || {};
    return properties.features || [];
  },
};
